<template>
    <div>
        <vs-sidebar position-right parent="body" default-index="1" class="sidebarx" v-model="active">
            <div class="content">
                <section class="section--sidebar-user">
                    <section class="section--title-sidebar">
                        <h3>Deadlines</h3>
                    </section>
                    <section class="section--content-sidebar section--content-sidebar-full-height">
                        <form method="POST" :action="this.action" accept-charset="UTF-8" enctype="multipart/form-data">
                            <input type="hidden" name="_token" :value="csrf">
                            <div class="form-group">
                                <div class="single--item">
                                    <div class="single--item-info">
                                        <h6>Status</h6>
                                    </div>
                                    <div class="single--item-info">
                                        <h6>Deadline</h6>
                                    </div>
                                    <div class="single--item-button">
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="single--item" v-for="(row,id) in parameters">
                                    <div class="single--item-info">
                                        <h6>{{row.status}}</h6>
                                    </div>
                                    <div class="single--item-info">
                                        <input type="date" :name="'deadline['+row.id+']'" v-model="row.deadline">
                                    </div>
                                    <div class="single--item-button">
                                        <button type="button" class="btn btn--only-icon-rounded" @click="clearDate(id)">
                                            <i class="far fa-times"></i>
                                        </button> 
                                    </div>
                                </div>
                            </div>
                            <div class="form-buttons clear">
                                <button type="submit" class="btn btn--green">{{ __('misc.update') }} </button>
                            </div>

                        </form>
                    </section>
                </section>
            </div>
        </vs-sidebar>
    </div>
</template>

<script>

  export default {
    // <multiselect v-model="value" :options="options"></multiselect>
    // OR register locally
    //components: { Multiselect },
    data () {
      return {
        value: null,
        editing: false,
        active: false,
        action: "",
        title: "",
        parameters: {},
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        selectedPerson: {},
        selectedRole: {},

      }
    },
    methods: {
        clearDate(id){

            this.parameters[id].deadline = null;
        },

      toggle(action, item_id, editing, attributes) {

        this.active = true;
        this.action = action;
        this.editing = editing;
        this.title = attributes.title;
        let url = attributes.url;
        if (url!==undefined) {
          if (url.indexOf("[id]")>0) {
            url = url.replace("[id]", item_id);
          }
          axios.get(url)
              .then((response) => {
                this.parameters = response.data;
                  //$("#spinnerWait").css('display',"none");
              });
        }
      }
    },
    mounted() {
    },
    props: {
        deadlines: {
        type: Array,
        required: true
      },

    }

  }
</script>
